import * as THREE from 'three';

export class CharacterMesh {
	/**
	 * Core
	 */
	threeMesh: THREE.Mesh;
	initialMaterial: THREE.Material;

	/**
	 * Constructor
	 * */
	constructor(mesh: THREE.Mesh) {
		this.threeMesh = mesh;
		this.initialMaterial = mesh.material as THREE.Material;
	}

	applyNewMaterial(material: THREE.Material) {
		this.threeMesh.material = material;
	}

	revertMaterial() {
		this.threeMesh.material = this.initialMaterial;
	}
}
